import React from "react";
import { AlertCircle } from "lucide-react";

interface ValidationErrorMessageProps {
  message: string | undefined;
}

const ValidationErrorMessage: React.FC<ValidationErrorMessageProps> = ({ message }) => {
  if (!message) return null;

  return (
    <p className="flex items-center gap-2 mt-1 text-sm text-error-600">
      <AlertCircle className="w-4 h-4 flex-shrink-0" />
      <span>{message}</span>
    </p>
  );
};

export { ValidationErrorMessage };
